import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WarehouseReceiptStatus } from '../../enums/warehouse-receipt-status';
import { WarehouseReceiptStatusPipe } from '../../pipes/warehouse-receipt-status.pipe';

@Component({
  selector: 'app-warehouse-receipt-status',
  imports: [CommonModule, WarehouseReceiptStatusPipe],
  templateUrl: './warehouse-receipt-status.component.html',
  styleUrl: './warehouse-receipt-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseReceiptStatusComponent {
  public readonly status = input.required<WarehouseReceiptStatus>();
}
